export default __webpack_public_path__ + "static/media/get_vip_okara.f11e8c74.svg";